import { configureStore, Store } from '@reduxjs/toolkit';

import { isDevEnv } from '../helpers';

import middleware from './middleware';
import { AppState, rootReducer } from './reducers/root';

export type AppDispatch = typeof store.dispatch;

function configureAppStore(initialState?: AppState): Store<AppState> {
  const appStore = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({ serializableCheck: false }).concat(middleware),
    devTools: isDevEnv(),
    preloadedState: initialState,
  });

  if (isDevEnv() && module.hot) {
    module.hot.accept('../store/reducers/root', () =>
      appStore.replaceReducer(rootReducer)
    );
  }

  return appStore;
}

const store = configureAppStore();

export default store;
